import { GlobalSearchResultType } from 'GlobalSearchResult';
import { ActivityLogPageFilters } from './activityLogPageUtils';

export const associatedTypeLabelMap: Record<string, string> = {
  '': 'Any',
  CONTACT: 'Contact',
  FUND_OPPORTUNITY: 'Fund Opportunity',
  INVESTOR: 'Investor',
  ADMIN_USER: 'Admin User',
  INVESTMENT_ENTITY: 'Investment Entity',
  GLOBAL_CONFIG: 'Global Config',
  ARTICLE: 'Article',
};

export function getInitiatorTypesForSearch(initiatedByType: string): GlobalSearchResultType[] {
  if (initiatedByType === 'CONTACT') return ['Contact'];
  if (initiatedByType === 'ADMIN_USER') return ['AdminUser'];
  return ['Contact', 'AdminUser'];
}

export function getInitiatorTypeLabel(initiatedByType: string): string {
  return initiatedByType === 'CONTACT'
    ? 'Contact'
    : initiatedByType === 'ADMIN_USER'
      ? 'Admin User'
      : 'Any';
}

export function getSelectedModelTypes(value: string | string[]): string[] {
  if (Array.isArray(value)) return value;
  return value ? [value] : [];
}

export function getModelTypeLabel(
  selectedTypes: string[],
  labelMap: Record<string, string> = associatedTypeLabelMap,
): string {
  return selectedTypes.length === 0
    ? 'Any'
    : selectedTypes.length === 1
      ? labelMap[selectedTypes[0]] || 'Any'
      : 'Multiple';
}

export function mapToSearchTypes(modelTypes: string[]): GlobalSearchResultType[] {
  const mapping: Record<string, GlobalSearchResultType | null> = {
    CONTACT: 'Contact',
    FUND_OPPORTUNITY: 'FundOpportunity',
    INVESTOR: null,
    ADMIN_USER: null,
    INVESTMENT_ENTITY: 'InvestmentEntity',
    GLOBAL_CONFIG: null,
    ARTICLE: 'Article',
  };
  const mapped = modelTypes.map((t) => mapping[t]).filter((v): v is GlobalSearchResultType => !!v);
  if (mapped.length === 0 && modelTypes.length === 0) {
    return ['Contact', 'FundOpportunity', 'InvestmentEntity', 'Article'];
  }
  return mapped;
}

export function toggleModelTypeFilter(current: string[], value: string): string[] {
  if (value === '__ANY__') return [];
  if (current.includes(value)) return current.filter((t) => t !== value);
  return [...current, value];
}

export const modelTypeFilterOptions = [
  'CONTACT',
  'FUND_OPPORTUNITY',
  'INVESTOR',
  'ADMIN_USER',
  'INVESTMENT_ENTITY',
  'GLOBAL_CONFIG',
  'ARTICLE',
] as const;

export type ActivityLogPageFilterField = keyof ActivityLogPageFilters;
